var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.25004H5.20833M5.20833 6.25004H21.875M5.20833 6.25004V20.8334C5.20833 21.3859 5.42783 21.9158 5.81853 22.3065C6.20923 22.6972 6.73913 22.9167 7.29167 22.9167H17.7083C18.2609 22.9167 18.7908 22.6972 19.1815 22.3065C19.5722 21.9158 19.7917 21.3859 19.7917 20.8334V6.25004M8.33333 6.25004V4.16671C8.33333 3.61417 8.55283 3.08427 8.94353 2.69357C9.33423 2.30287 9.86413 2.08337 10.4167 2.08337H14.5833C15.1359 2.08337 15.6658 2.30287 16.0565 2.69357C16.4472 3.08427 16.6667 3.61417 16.6667 4.16671V6.25004M10.4167 11.4584V17.7084M14.5833 11.4584V17.7084",
    stroke: "#3373EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.2cf7e3d277c6f3dba82c2553d2595dbc.svg";
export { ForwardRef as ReactComponent };